import AboutUs2Container from "../../../components/pages/other/aboutUs2";

const AboutUs2 = () => {
  return <AboutUs2Container />;
};

export default AboutUs2;
